import _ArrowRightAlt from "@mui/icons-material/ArrowRightAlt";
import React from 'react';
import { LinkOnComponent } from 'app/components/links/link';
import { COLORS, Image, ImageBadge, ImageEntity, SIZES } from '@fupa/fupa-uikit';
import { Emblem } from 'app/components/icons';
import styled from 'styled-components';
const TransferImages = styled.div.withConfig({
  componentId: "sc-rb6mlo-0"
})(["display:flex;justify-content:space-around;align-items:center;width:80%;"]);
const ImageContainer = styled.div.withConfig({
  componentId: "sc-rb6mlo-1"
})(["height:", ";position:relative;"], SIZES[64]);
export default function VisualTransfer(_ref) {
  let {
    data
  } = _ref;
  const fromTeamBadge = data.fromTeam ? /*#__PURE__*/React.createElement(ImageBadge, {
    value: data.fromTeam.getEmblem(),
    position: 1,
    fit: true
  }) : null;
  const toTeamEmblem = data.toTeam ? /*#__PURE__*/React.createElement(LinkOnComponent, {
    to: data.toTeam.getLink()
  }, /*#__PURE__*/React.createElement(ImageContainer, null, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Emblem,
    src: data.toTeam.getEmblem(),
    width: 64,
    height: 64,
    fit: true
  }))) : /*#__PURE__*/React.createElement(Emblem, {
    style: {
      color: COLORS.lightGrey,
      fontSize: 64
    }
  });
  return /*#__PURE__*/React.createElement(TransferImages, {
    "data-sentry-element": "TransferImages",
    "data-sentry-component": "VisualTransfer",
    "data-sentry-source-file": "VisualTransfer.tsx"
  }, /*#__PURE__*/React.createElement(LinkOnComponent, {
    to: data.getLink(),
    "data-sentry-element": "LinkOnComponent",
    "data-sentry-source-file": "VisualTransfer.tsx"
  }, /*#__PURE__*/React.createElement(ImageContainer, {
    "data-sentry-element": "ImageContainer",
    "data-sentry-source-file": "VisualTransfer.tsx"
  }, /*#__PURE__*/React.createElement(Image, {
    entity: ImageEntity.Player,
    src: data.getProfileImage(),
    ratio: "1:1",
    width: 64,
    height: 64,
    circle: true,
    "data-sentry-element": "Image",
    "data-sentry-source-file": "VisualTransfer.tsx"
  }), fromTeamBadge)), /*#__PURE__*/React.createElement(_ArrowRightAlt, {
    color: "action",
    "data-sentry-element": "ArrowRightAlt",
    "data-sentry-source-file": "VisualTransfer.tsx"
  }), toTeamEmblem);
}